var exports = {
  "q": "sidebarSectionsLoadingContainer__GO0Kiu",
};

module.exports = exports;
